import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface BannerProps {
  message: React.ReactNode;
}

export default function Banner(props: BannerProps): JSX.Element {
  return (
    <div className="buffer-options-item-banner u-ellipsis-text">
      <BenchlingIcon icon="info-circle" className="buffer-options-item-banner-icon" />
      <span
        {...getTestProps({
          component: 'Banner',
          element: 'text',
        })}
      >
        {props.message}
      </span>
    </div>
  );
}
